import { isUndefined } from 'lodash';
import { PROGRAM_CONFIG } from 'utils/constants';
import Program from 'utils/program';
import {
  DATE_FORMATS,
  DEFAULT_TIMEZONE,
  dateWithTimezone,
} from 'utils/dateTime';

interface IDefaultHeaderType {
  Accept: string;
  'Content-Type': string;
  Program?: string;
}

export const isJsonString = (jsonString: any): boolean => {
  try {
    JSON.parse(jsonString);
  } catch (e) {
    return false;
  }
  return true;
};

export const getDefaultHeaders = (): IDefaultHeaderType => {
  const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  };

  const program = Program.get();
  if (isUndefined(program)) return { ...defaultHeaders };

  return {
    ...defaultHeaders,
    Program: PROGRAM_CONFIG[program]?.header || program,
  };
};

export const transformPrescription = (
  prescription: IApiPrescription,
): IPrescription => {
  const { startDate, expireAt, timezone } = prescription;
  return {
    ...prescription,
    timezone: prescription.timezone || DEFAULT_TIMEZONE,
    startDateWithTimezone: startDate
      ? // moment strict mode enforced in dateWithTimezone function
        dateWithTimezone(timezone, startDate, DATE_FORMATS.UTC_DATE_TIME)
      : null,
    endDateWithTimezone: expireAt
      ? dateWithTimezone(timezone, expireAt, DATE_FORMATS.UTC_DATE_TIME)
      : null,
  };
};
